import React from "react";
import {
  Column,
  Lookup,
  DataGrid,
  Paging,
  Pager,
  HeaderFilter,
  FilterRow,
  FormItem,
  Selection,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
  criarUnidadeFiscal,
  criarUsuariosPrefeituraDs,
  criarGrupoRecursoDs,
} from "../../DataSources";
import UserInfo from "../../UserInfo";
import uiInfo from "../../ui-info";
import notify from "devextreme/ui/notify";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import api from "../../api-axios";
import ShowError from "../../AppServices";

export default class UsuariosPrefeituraBox extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.gridRef = React.createRef();
    this.usuariosDs = criarUsuariosPrefeituraDs();
    this.gruposDs = criarGrupoRecursoDs();
    this.vincularGrupos = this.vincularGrupos.bind(this);
    this.editarPermissoes = this.editarPermissoes.bind(this);
    this.onSelection = this.onSelection.bind(this);
    this.confirmarVinculacao = this.confirmarVinculacao.bind(this);

    this.state = {
      carregando: true,
      grupos: [],
    };
  }

  onSelection(e) {
    console.log(e);
    this.setState({
      gruposIds: e.selectedRowsData.map((x) => x.id),
    });

    console.log(this.state.gruposIds);
  }

  componentDidMount() {
    this.gruposDs.load().then((resp) => {
      this.setState({ grupos: resp });
    });
  }

  vincularGrupos(e) {
    console.log(e);
    this.setState({
      pupupGrupos: true,
      usuarioId: e.row.data.id,
      gruposIds: e.row.data.gruposIds,
    });
  }

  confirmarVinculacao() {
    api
      .post(`/usuarios/vincular_usuario_grupo/${UserInfo.getPrefeitura()}/`, {
        usuarioId: this.state.usuarioId,
        gruposIds: this.state.gruposIds,
      })
      .then((_) => {
        this.setState({
          pupupGrupos: false,
          usuarioId: null,
          gruposIds: [],
        });
        notify("Vinculação feita com sucesso.", "success");
        this.gridRef.instance.refresh();
      })
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  editarPermissoes(e) {
    console.log("data row", e);
    this.props.history.push({
      pathname: "/permissoes",
      state: {
        usuarioId: e.row.data.id,
        login: e.row.data.login,
        usuarioNome: e.row.data.nome,
        cpfCnpj: e.row.data.cpfCnpj,
      },
    });
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar titulo="Usuários da Prefeitura">
          <DataGrid
            ref={(grid) => (this.gridRef = grid)}
            dataSource={this.usuariosDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            focusedRowEnabled={true}
            wordWrapEnabled={true}
          >
            <HeaderFilter visible={true} />
            <FilterRow visible={true} />
            <Editing
              mode={"row"}
              allowAdding={false}
              allowUpdating={false}
              allowDeleting={false}
              useIcons={true}
            />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  icon: "group",
                  onClick: (e) => this.vincularGrupos(e),
                },
                {
                  icon: "preferences",
                  onClick: (e) => this.editarPermissoes(e),
                },
              ]}
            />
            <Column dataField={"login"} caption={"Login"} width={160} />
            <Column dataField={"subPerfil"} caption={"Perfil"} width={100} />
            <Column dataField={"cpfCnpj"} caption={"CPF/CNPJ"} width={160} />
            <Column dataField={"nome"} caption={"Nome"} />
            <Column dataField={"gruposStr"} caption={"Grupos"} />

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>

        <Popup
          visible={this.state.pupupGrupos}
          closeOnOutsideClick={true}
          onHiding={() => this.setState({ pupupGrupos: false })}
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"60%"}
          height={500}
          title="Grupos"
        >
          <DataGrid
            dataSource={this.state.grupos}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={true}
            allowColumnReordering={true}
            key={"id"}
            keyExpr={"id"}
            height={"100%"}
            width={"100%"}
            onSelectionChanged={(e) => this.onSelection(e)}
            selectedRowKeys={this.state.gruposIds}
          >
            <Paging enabled={false} />
            <Selection
              mode="multiple"
              selectAllMode="allPages"
              showCheckBoxesMode="always"
            />
            <Column dataField={"nome"} allowEditing={false} />
          </DataGrid>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => this.setState({ pupupGrupos: false }),
            }}
          />
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Atualizar",
              type: "success",
              width: 150,
              onClick: () => {
                this.confirmarVinculacao();
              },
            }}
          />
        </Popup>
      </div>
    );
  }
}
